module.exports = __webpack_public_path__ + "static/img/14areaB_1.1e56032.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_1.png
// module id = 1115
// module chunks = 1